import React, { SVGProps } from 'react';

export const UserIconLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="30" height="30" viewBox="0 0 24 24" {...props}>
    <path
      d="M11.992 6.25A3.25 3.25 0 0 0 8.738 9.5a3.25 3.25 0 0 0 3.254 3.25 3.25 3.25 0 0 0 3.253-3.25 3.25 3.25 0 0 0-3.253-3.25M10.238 9.5c0-.965.784-1.75 1.754-1.75.969 0 1.753.785 1.753 1.75 0 .966-.784 1.75-1.753 1.75-.97 0-1.754-.784-1.754-1.75"
      clipRule="evenodd"
    />
    <path d="M8.042 17.518c2.05-2.148 5.86-2.23 7.906-.01a.75.75 0 0 0 1.104-1.016c-2.668-2.895-7.481-2.747-10.094-.01a.75.75 0 1 0 1.084 1.036" />
    <path
      d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0"
      clipRule="evenodd"
    />
  </svg>
);
